
const DenyAndEmail = theme => ({
    modalBody: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingLeft: 18,
        paddingRight: 18,
        paddingTop: 20
    },
    contentWrapper: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10
    },
    contentWrapperNoAlign: {
        display: "flex",
        marginBottom: 40,
    },
    titleText: {
        width: "140px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    titleTextEmail: {
        width: "140px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        marginTop: 7,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    menuItemWidth: {
        minWidth: 300,
        maxWidth: 350
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    productInput: {
        flexGrow: 1,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    productInputError: {
        flexGrow: 1,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid red",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    textInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        paddingTop: 5,
        resize: "none",
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },

    textInputError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        paddingTop: 5,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        resize: "none",
        border: "1px solid red",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },
    textArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 250,
        border: "1px solid #979797",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    textAreaError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 250,
        border: "1px solid red",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    textAreaReason: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 100,
        border: "1px solid #979797",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    textAreaReasonError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 100,
        border: "1px solid red",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 197,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 197,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginBottom: 15
    },
})

export default DenyAndEmail;